var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M22.667 26.667a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.384-.95v-6.666q0-.567.384-.95a1.3 1.3 0 01.95-.384h2.666q.567 0 .95.384.384.383.384.95v6.666q0 .567-.384.95a1.3 1.3 0 01-.95.384zm-8 0a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.384-.95V6.667q0-.567.384-.95a1.3 1.3 0 01.95-.384h2.666q.567 0 .95.384.384.383.384.95v18.666q0 .567-.384.95a1.3 1.3 0 01-.95.384zm-8 0a1.3 1.3 0 01-.95-.384 1.3 1.3 0 01-.384-.95v-12q0-.566.384-.95a1.3 1.3 0 01.95-.383h2.666q.567 0 .95.383.384.384.384.95v12q0 .567-.384.95a1.3 1.3 0 01-.95.384z"
  })));
}
export default SvgBarChart;